import React from "react";
import { gql } from "@apollo/client";

import { Typography } from "@mui/material";
import { EarHearing as SoundShapeIcon } from "mdi-material-ui";

const Icon = () => <SoundShapeIcon />;

const Title = () => <span>Sound shaping</span>;

const Content = ({ orderEvent }) => (
  <Typography variant="h4" color="primary" component="div">
    {orderEvent.soundShaping.mouthpieceRef.name}
  </Typography>
);

const fragments = {
  orderEvent: gql`
    fragment Orders_OrderEvent_SoundShapeEvent_OrderEvent on OrderEvent {
      id

      ... on OrderEvent_SoundShape {
        soundShaping {
          id
          mouthpieceRef {
            id
            name
          }
        }
      }
    }
  `,
};

const Event = {
  Icon,
  Title,
  Content,
  fragments,
};

export default Event;
